// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Port\ApiPort.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';
import { Location, LocationData, LocationOptions } from 'data/models/Location';
import { PierGroup, PierGroupData, PierGroupOptions } from 'data/models/PierGroup';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PortCDMDestination, PortCDMDestinationData, PortCDMDestinationOptions } from 'data/models/PortCDMDestination';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';

// PortData is the class that Port serializes to/from
export interface PortData {
    Id : number;
    Url : string | null;
	
    Domain : DomainData | null;
    DomainId : number;
    Locations : LocationData[] | null;
    PierGroups : PierGroupData[] | null;
    PortCalls : PortCallData[] | null;
    PortCDMDestination : PortCDMDestinationData | null;
    RecurringBatches : RecurringBatchData[] | null;
	
    Guid : /* GUID */ string;
    InboundDemarcationName : string | null;
    Name : string;
    Order : number;
    PierDepthUOM : string | null;
    PierLengthUOM : string | null;
    UNLOCODE : string | null;
}

// PortOptions is the class which may be passed to the Port constructor to define optional initial data values
export interface PortOptions {
    Id : number;
    Url? : string | null;
	
    Domain? : DomainOptions | null;
    DomainId? : number;
    Locations? : LocationOptions[] | null;
    PierGroups? : PierGroupOptions[] | null;
    PortCalls? : PortCallOptions[] | null;
    PortCDMDestination? : PortCDMDestinationOptions | null;
    RecurringBatches? : RecurringBatchOptions[] | null;
	
    Guid? : /* GUID */ string;
    InboundDemarcationName? : string | null;
    Name? : string;
    Order? : number;
    PierDepthUOM? : string | null;
    PierLengthUOM? : string | null;
    UNLOCODE? : string | null;
}

export class Port {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Domain : DataSignal<Domain | null>;
    public DomainId : DataSignal<number>;
    public Locations : SDataArray<Location>;
    public PierGroups : SDataArray<PierGroup>;
    public PortCalls : SDataArray<PortCall>;
    public PortCDMDestination : DataSignal<PortCDMDestination | null>;
    public RecurringBatches : SDataArray<RecurringBatch>;
	
    public Guid : DataSignal<string>;
    public InboundDemarcationName : DataSignal<string | null>;
    public Name : DataSignal<string>;
    public Order : DataSignal<number>;
    public PierDepthUOM : DataSignal<string | null>;
    public PierLengthUOM : DataSignal<string | null>;
    public UNLOCODE : DataSignal<string | null>;

    constructor();
    constructor(data : PortOptions);
    constructor(data: PortOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Domain = S.value<Domain | null>(null);
        this.DomainId = jsonableObservable(S.value<number>(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Locations = SArray<Location>([]);
        this.PierGroups = SArray<PierGroup>([]);
        this.PortCalls = SArray<PortCall>([]);
        this.PortCDMDestination = S.value<PortCDMDestination | null>(null);
        this.RecurringBatches = SArray<RecurringBatch>([]);
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.InboundDemarcationName = jsonableObservable(S.value<string | null>(data && data.InboundDemarcationName !== undefined ? data.InboundDemarcationName : null));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
        this.PierDepthUOM = jsonableObservable(S.value<string | null>(data && data.PierDepthUOM !== undefined ? data.PierDepthUOM : null));
        this.PierLengthUOM = jsonableObservable(S.value<string | null>(data && data.PierLengthUOM !== undefined ? data.PierLengthUOM : null));
        this.UNLOCODE = jsonableObservable(S.value<string | null>(data && data.UNLOCODE !== undefined ? data.UNLOCODE : null));
    }

    static key(obj : Port) {
        return obj.Id();
    }
    
    static dataKey(obj : PortOptions) {
        return obj.Id;
    }

    static update(obj : Port, data : PortOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.DomainId !== undefined) obj.DomainId(data.DomainId);
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.InboundDemarcationName !== undefined) obj.InboundDemarcationName(data.InboundDemarcationName);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Order !== undefined) obj.Order(data.Order);
            if (data.PierDepthUOM !== undefined) obj.PierDepthUOM(data.PierDepthUOM);
            if (data.PierLengthUOM !== undefined) obj.PierLengthUOM(data.PierLengthUOM);
            if (data.UNLOCODE !== undefined) obj.UNLOCODE(data.UNLOCODE);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Port.ts